module.exports = __webpack_public_path__ + "media/images/flags/16/Mozambique-c383c1bea2e2662893f59203b65567ee.png";